export default __webpack_public_path__ + "static/media/js.9e6ca937.png";